import { createContext, useContext, useState, useEffect, useMemo } from "react";

const UniverseContext = createContext(null);

export function UniverseProvider({ children }) {
  const [universe, setUniverse] = useState(() => localStorage.getItem("frenchies_universe") || "fitness");

  useEffect(() => {
    localStorage.setItem("frenchies_universe", universe);
    const root = document.documentElement;
    if (universe === "pilates") root.classList.add("universe-pilates");
    else root.classList.remove("universe-pilates");
  }, [universe]);

  const value = useMemo(() => ({ universe, setUniverse }), [universe]);

  return (
    <UniverseContext.Provider value={value}>
      {children}
    </UniverseContext.Provider>
  );
}

export const useUniverse = () => useContext(UniverseContext);
